import React from "react";
import { getIcon, getMarkerIcons } from "../../../utils/images";
import "./ShipmentMapPopup.scss";

const ShipmentMapPopupEntry = ({ name, shipment, selectShipment }) => {
  const isPol = shipment.pol.name === name
  return (
    <div className="ShipmentMapPopupEntry">
      <div className="main">
        <div className="main__title">
          <div>
            {shipment.booking_number || shipment.bl}
          </div>
          <div className="main__icon">
            <img src={getMarkerIcons(isPol ? 'small-pol' : 'small-pod')} /><span>{isPol ? "POL" : "POD"}</span>
          </div>
        </div>
        <div className="main__subtitle">
          <span>{shipment.pol.name}</span><span>{">"}</span><span>{shipment.pod.name}</span>
        </div>
      </div>
      <div className="eye" onClick={() => selectShipment(shipment)}><img src={getIcon('eye')} /></div>
    </div>
  )
}


const ShipmentMapPopup = ({ name, shipments, selectShipment }) => {
  return (
    <div className="ShipmentMapPopup">
      <div className="pop-header">
        <div className="icon"><img src={getIcon('marker')} /></div>
        <div className="name">{name}</div>
      </div>
      <div className="body">
        {shipments?.map((shipment, index) => <ShipmentMapPopupEntry key={index} name={name} shipment={shipment} selectShipment={selectShipment} />)}
      </div>
    </div>
  )
};

export default ShipmentMapPopup;
